import { Component } from '@angular/core';
import { TenantService } from '../services/tenant.service';
import { PageviewsettingsService } from '../services/pageviewsettings.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-giveaway-closed',
  templateUrl: './giveaway-closed.component.html',
  styleUrls: ['./giveaway-closed.component.css']
})

export class GiveawayClosedComponent {
	tenant: TenantService;
	loadeddata: any;
	tenantId: any;
	affiliateId: any;
	iconsWithLabels: { icon: string; label: string }[] = [];

	constructor(private tenantService: TenantService, private settingsService: PageviewsettingsService, private route: ActivatedRoute,) {
		this.tenant = this.tenantService;
	}

	ngOnInit() {
		let collegeName = this.route.snapshot.paramMap.get('collegemobile') || '/defaultpage';

		this.settingsService.getCollegetenantcode(collegeName).subscribe((data: { result: { id: string; affiliateId: any; }; }) => {
			this.tenantId = parseInt(data.result.id)
			this.affiliateId = data.result.affiliateId
			this.loadPageSettings()
		});
	}

	loadPageSettings() {
		this.settingsService.getPageViewSettings(this.affiliateId, this.tenantId).subscribe(data => {
			this.loadeddata = data.result;
		});

		this.iconsWithLabels = this.tenant.getTenantIconItems();
	}
}
